{
    "v": "4.8.0",
    "meta": { "g": "LottieFiles AE ", "a": "", "k": "", "d": "", "tc": "" },
    "fr": 25,
    "ip": 0,
    "op": 50,
    "w": 500,
    "h": 500,
    "nm": "34 Costumer",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 9,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 24, "ix": 1 }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Mid line",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [50, 58, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 8, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-186.078, 8],
                                        [186.078, 8]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.047, 0.047, 0.047, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Customer 6",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 0,
                            "s": [179.714, 153.741, 0],
                            "to": [0, 8.667, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 8,
                            "s": [179.714, 205.741, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 4.5, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 17,
                            "s": [179.714, 153.741, 0],
                            "to": [0, -4.5, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 26,
                            "s": [179.714, 178.741, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 4.167, 0]
                        },
                        { "t": 34, "s": [179.714, 153.741, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [129.714, 103.741, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-16.778, 0],
                                        [0, 0],
                                        [0, -16.778]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, -16.778],
                                        [0, 0],
                                        [16.778, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [172.952, 156.245],
                                        [86.476, 156.245],
                                        [86.476, 131.033],
                                        [116.856, 100.653],
                                        [142.572, 100.653],
                                        [172.952, 131.033]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.157, 0.176, 0.212, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, -13.646],
                                        [13.646, 0],
                                        [0, 13.646],
                                        [-13.646, 0]
                                    ],
                                    "o": [
                                        [0, 13.646],
                                        [-13.646, 0],
                                        [0, -13.646],
                                        [13.646, 0]
                                    ],
                                    "v": [
                                        [154.422, 75.946],
                                        [129.714, 100.653],
                                        [105.007, 75.946],
                                        [129.714, 51.238]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.157, 0.176, 0.212, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Customer 5",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 3,
                            "s": [50, 153.741, 0],
                            "to": [0, 8.667, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 11,
                            "s": [50, 205.741, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 4.5, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 20,
                            "s": [50, 153.741, 0],
                            "to": [0, -4.5, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 29,
                            "s": [50, 178.741, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 4.167, 0]
                        },
                        { "t": 37, "s": [50, 153.741, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [0, 103.741, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-16.778, 0],
                                        [0, 0],
                                        [0, -16.778]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, -16.778],
                                        [0, 0],
                                        [16.778, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [43.238, 156.245],
                                        [-43.238, 156.245],
                                        [-43.238, 131.033],
                                        [-12.858, 100.653],
                                        [12.858, 100.653],
                                        [43.238, 131.033]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.047, 0.047, 0.047, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, -13.646],
                                        [13.646, 0],
                                        [0, 13.646],
                                        [-13.646, 0]
                                    ],
                                    "o": [
                                        [0, 13.646],
                                        [-13.646, 0],
                                        [0, -13.646],
                                        [13.646, 0]
                                    ],
                                    "v": [
                                        [24.707, 75.946],
                                        [0, 100.653],
                                        [-24.707, 75.946],
                                        [0, 51.238]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.047, 0.047, 0.047, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "Customer 4",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 6,
                            "s": [-80.486, 153.741, 0],
                            "to": [0, 8.667, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 14,
                            "s": [-80.486, 205.741, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 4.5, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 23,
                            "s": [-80.486, 153.741, 0],
                            "to": [0, -4.5, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 32,
                            "s": [-80.486, 178.741, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 4.167, 0]
                        },
                        { "t": 40, "s": [-80.486, 153.741, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [-130.486, 103.741, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-16.778, 0],
                                        [0, 0],
                                        [0, -16.778]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, -16.778],
                                        [0, 0],
                                        [16.778, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-87.248, 156.245],
                                        [-173.724, 156.245],
                                        [-173.724, 131.033],
                                        [-143.344, 100.653],
                                        [-117.628, 100.653],
                                        [-87.248, 131.033]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.157, 0.176, 0.212, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, -13.646],
                                        [13.646, 0],
                                        [0, 13.646],
                                        [-13.646, 0]
                                    ],
                                    "o": [
                                        [0, 13.646],
                                        [-13.646, 0],
                                        [0, -13.646],
                                        [13.646, 0]
                                    ],
                                    "v": [
                                        [-105.779, 75.946],
                                        [-130.486, 100.653],
                                        [-155.194, 75.946],
                                        [-130.486, 51.238]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.157, 0.176, 0.212, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "Customer 3",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 4,
                            "s": [179.714, -37.741, 0],
                            "to": [0, -11.167, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 12,
                            "s": [179.714, -104.741, 0],
                            "to": [0, 0, 0],
                            "ti": [0, -6, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 21,
                            "s": [179.714, -37.741, 0],
                            "to": [0, 6, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 30,
                            "s": [179.714, -68.741, 0],
                            "to": [0, 0, 0],
                            "ti": [0, -5.167, 0]
                        },
                        { "t": 38, "s": [179.714, -37.741, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [129.714, -87.741, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-16.778, 0],
                                        [0, 0],
                                        [0, -16.778]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, -16.778],
                                        [0, 0],
                                        [16.778, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [172.952, -35.238],
                                        [86.476, -35.238],
                                        [86.476, -60.45],
                                        [116.856, -90.83],
                                        [142.572, -90.83],
                                        [172.952, -60.45]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.047, 0.047, 0.047, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, -13.646],
                                        [13.646, 0],
                                        [0, 13.646],
                                        [-13.646, 0]
                                    ],
                                    "o": [
                                        [0, 13.646],
                                        [-13.646, 0],
                                        [0, -13.646],
                                        [13.646, 0]
                                    ],
                                    "v": [
                                        [154.422, -115.537],
                                        [129.714, -90.83],
                                        [105.007, -115.537],
                                        [129.714, -140.245]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.047, 0.047, 0.047, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "Customer 2",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 2,
                            "s": [50, -37.741, 0],
                            "to": [0, -11.167, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 10,
                            "s": [50, -104.741, 0],
                            "to": [0, 0, 0],
                            "ti": [0, -6, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 19,
                            "s": [50, -37.741, 0],
                            "to": [0, 6, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 28,
                            "s": [50, -68.741, 0],
                            "to": [0, 0, 0],
                            "ti": [0, -5.167, 0]
                        },
                        { "t": 36, "s": [50, -37.741, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [0, -87.741, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-16.778, 0],
                                        [0, 0],
                                        [0, -16.778]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, -16.778],
                                        [0, 0],
                                        [16.778, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [43.238, -35.238],
                                        [-43.238, -35.238],
                                        [-43.238, -60.45],
                                        [-12.858, -90.83],
                                        [12.858, -90.83],
                                        [43.238, -60.45]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.157, 0.176, 0.212, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, -13.646],
                                        [13.646, 0],
                                        [0, 13.646],
                                        [-13.646, 0]
                                    ],
                                    "o": [
                                        [0, 13.646],
                                        [-13.646, 0],
                                        [0, -13.646],
                                        [13.646, 0]
                                    ],
                                    "v": [
                                        [24.707, -115.537],
                                        [0, -90.83],
                                        [-24.707, -115.537],
                                        [0, -140.245]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.157, 0.176, 0.212, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "Customer 1",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 0,
                            "s": [-80.486, -37.741, 0],
                            "to": [0, -11.167, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 8,
                            "s": [-80.486, -104.741, 0],
                            "to": [0, 0, 0],
                            "ti": [0, -6, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 17,
                            "s": [-80.486, -37.741, 0],
                            "to": [0, 6, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.6, "y": 1 },
                            "o": { "x": 0.4, "y": 0 },
                            "t": 26,
                            "s": [-80.486, -68.741, 0],
                            "to": [0, 0, 0],
                            "ti": [0, -5.167, 0]
                        },
                        { "t": 34, "s": [-80.486, -37.741, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [-130.486, -87.741, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-16.778, 0],
                                        [0, 0],
                                        [0, -16.778]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, -16.778],
                                        [0, 0],
                                        [16.778, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-87.248, -35.238],
                                        [-173.724, -35.238],
                                        [-173.724, -60.45],
                                        [-143.344, -90.83],
                                        [-117.628, -90.83],
                                        [-87.248, -60.45]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.047, 0.047, 0.047, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, -13.646],
                                        [13.646, 0],
                                        [0, 13.646],
                                        [-13.646, 0]
                                    ],
                                    "o": [
                                        [0, 13.646],
                                        [-13.646, 0],
                                        [0, -13.646],
                                        [13.646, 0]
                                    ],
                                    "v": [
                                        [-105.779, -115.537],
                                        [-130.486, -90.83],
                                        [-155.194, -115.537],
                                        [-130.486, -140.245]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.047, 0.047, 0.047, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 9,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
